import React from 'react';
import PropTypes from 'prop-types';
import { useRoutes, Navigate } from 'react-router-dom';
import ROUTE_PATH from '../config/routes.config';
import LoginView from '../views/auth/login.view';
import DashboardView from '../views/dashboard/dashboard.view';
import ContentChannelsView from '../views/content/channels.view';
import ContentVideosView from '../views/content/videos.view';
import ContentSettingsView from '../views/content/settings.view';
import AdminUsersView from '../views/admin-users/admin-users.view';
import PageNotFoundView from '../views/errors/not-found.view';
import LogoutView from '../views/auth/logout.view';
import ContentCategoriesView from '../views/content/categories.view';
import ContentSequenceView from '../views/content/sequence.view';
import {
  DEFAULT_CHANNEL,
  SHOW_ADMIN_USERS,
  SHOW_CONTENT_CATEGORIES,
  SHOW_CONTENT_SHOWS,
  SHOW_CONTENT_VIDEOS,
  SHOW_OVERVIEW_DASHBOARD,
  SHOW_REPORTS_APP_SESSIONS,
  SHOW_REPORTS_LIVE_USERS,
  SHOW_REPORTS_OVERVIEW_VIDEOS,
  SHOW_REPORTS_WATCH_SESSIONS,
  SHOW_SUBSCRIBERS,
  SHOW_WEB_CONTENT,
  SHOW_CONTACTS,
} from '../config/const.config';
import ContentShowsView from '../views/content/shows.view';
import WebContentView from '../views/content/web-content.view';
import SubscribersView from '../views/subscribers/subscribers.view';
import ReportsOverviewView from '../views/reports/overview.view';
import ReportsWatchSessionsView from '../views/reports/watch-sessions.view';
import ReportsVideoWatchSessionsView from '../views/reports/video-watch-session.view';
import ReportsAppSessionsView from '../views/reports/app-sessions.view';
import ReportsLiveUsersView from '../views/reports/live-users.view';
import ContactsView from '../views/contact/contacts.view';

const AppRouter = ({ isLoggedIn }) => {
  const routeMappings = [];

  if (isLoggedIn) {
    routeMappings.push({
      path: ROUTE_PATH.LOGIN,
      element: <Navigate to={ROUTE_PATH.DASHBOARD} />,
      exact: true,
    });

    if (SHOW_OVERVIEW_DASHBOARD) {
      routeMappings.push({
        path: ROUTE_PATH.DASHBOARD,
        element: <DashboardView />,
        exact: true,
      });
    }

    if (!DEFAULT_CHANNEL) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_CHANNELS,
        element: <ContentChannelsView />,
        exact: true,
      });
    }

    if (SHOW_CONTENT_CATEGORIES) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_CATEGORIES,
        element: <ContentCategoriesView />,
        exact: true,
      });
    }

    if (SHOW_CONTENT_SHOWS) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_SHOWS,
        element: <ContentShowsView />,
        exact: true,
      });
    }

    if (SHOW_CONTENT_VIDEOS) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_VIDEOS,
        element: <ContentVideosView videoContentType="videos" />,
        exact: true,
      });
    }

    if (SHOW_WEB_CONTENT) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_WEB,
        element: <WebContentView />,
        exact: true,
      });
    }
    if (DEFAULT_CHANNEL) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_SEQUENCE,
        element: <ContentSequenceView />,
        exact: true,
      });
    }
    if (DEFAULT_CHANNEL) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_SETTINGS,
        element: <ContentSettingsView />,
        exact: true,
      });
    }

    if (SHOW_ADMIN_USERS) {
      routeMappings.push({
        path: ROUTE_PATH.ADMIN_USERS,
        element: <AdminUsersView />,
        exact: true,
      });
    }
    if (SHOW_SUBSCRIBERS) {
      routeMappings.push({
        path: ROUTE_PATH.SUBSCRIBERS,
        element: <SubscribersView />,
        exact: true,
      });
    }
    
    if (SHOW_CONTACTS) {
      routeMappings.push({
        path: ROUTE_PATH.CONTACTS,
        element: <ContactsView />,
        exact: true,
      });
    }

    if (SHOW_REPORTS_OVERVIEW_VIDEOS) {
      routeMappings.push({
        path: ROUTE_PATH.REPORTS_OVERVIEW_VIDEOS,
        element: <ReportsOverviewView />,
        exact: true,
      });
    }
    if (SHOW_REPORTS_LIVE_USERS) {
      routeMappings.push({
        path: ROUTE_PATH.REPORTS_LIVE_USERS,
        element: <ReportsLiveUsersView />,
        exact: true,
      });
    }
    if (SHOW_REPORTS_WATCH_SESSIONS) {
      routeMappings.push({
        path: ROUTE_PATH.REPORTS_WATCH_SESSIONS,
        element: <ReportsWatchSessionsView />,
        exact: true,
      });
    }
    if (SHOW_REPORTS_WATCH_SESSIONS) {
      routeMappings.push({
        path: ROUTE_PATH.REPORTS_VIDEO_WATCH_SESSIONS,
        element: <ReportsVideoWatchSessionsView />,
        exact: true,
      });
    }
    
    if (SHOW_REPORTS_APP_SESSIONS) {
      routeMappings.push({
        path: ROUTE_PATH.REPORTS_APP_SESSIONS,
        element: <ReportsAppSessionsView />,
        exact: true,
      });
    }


    routeMappings.push({
      path: ROUTE_PATH.LOGOUT,
      element: <LogoutView />,
      exact: true,
    });
  }

  routeMappings.push({
    path: '*',
    element: isLoggedIn ? <PageNotFoundView /> : <LoginView />,
  });

  const routes = useRoutes(routeMappings);

  return routes;
};

AppRouter.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default AppRouter;
